import React from 'react';
import styles from './MainPainItem.module.css';
import Icon from "@mui/icons-material/Close";

const MainPainItem = ({ label, enabled,  OnRemove }) => {

    function OnClickHandler()
    {
        if (OnRemove)
            OnRemove(label);
    }
    
    // Função para substituir a sequência literal de caracteres "\n" por quebras de linha reais
    function processText(text) {
        return text ? text.replace(/\n/g, '\n') : '';
    }

    return (
        <div className={styles.container} >
           <span style={{ whiteSpace: 'pre-line' }}>{processText(label)}</span>
           {enabled && (
             <span className={styles.remove} onClick={OnClickHandler} role="button" aria-label="Remover queixa">
               <Icon sx={{ fontSize: 16 }} />
             </span>
           )}
        </div>
    );
};

export default MainPainItem;
